import { render } from "./slim-custom.vue?vue&type=template&id=68c2dfe2"
import script from "./slim-custom.vue?vue&type=script&lang=js"
export * from "./slim-custom.vue?vue&type=script&lang=js"

import "./slim-custom.vue?vue&type=style&index=0&id=68c2dfe2&lang=css"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__